import clsxm from '@/lib/clsxm';

import Typography from '@/components/typography';

import { formatThreeLetterMonth } from '@/utils/date-utils';

export type DatePublishedModifiedProps = {
  datePublished: string;
  dateModified: string;
  className?: string;
};

export default function DatePublishedModified({
  className,
  datePublished,
  dateModified,
}: DatePublishedModifiedProps) {
  return (
    <div className={clsxm('flex gap-4', className)}>
      <Typography.Body35 className='text-grey500'>
        Published: {formatThreeLetterMonth(datePublished)}
      </Typography.Body35>

      <Typography.Body35 className='text-grey500'>
        Modified: {formatThreeLetterMonth(dateModified)}
      </Typography.Body35>
    </div>
  );
}
